import React from 'react';
import data from './Home.data.json';
import './Home.style.scss';

const Home = () => {
  return (
    <div>
      <h1>Marvel Comics</h1>
      <p className="paragraph">{data.marvel.description}</p>
    </div>
  );
};

export default Home;
